import { C } from "@/helpers/global";

export class UserRefreshTokenLogin {
    constructor(refreshToken) {
        this.refreshToken = C.Str(refreshToken);
    }
}